import http from '../utility/http';

export default {
    namespaced: true,
    state: {
        error: undefined
    },
    actions: {
        async signupUser(context, user) {
            try {
                await http.post('/users', {
                    email: user.email,
                    name: 'Doug',
                    password: user.password
                });
            } catch (error) {
                context.commit('error', error);
            }
        },
        async verifyUser(context, token) {
            try {
                await http.post('/users/verify', {
                    token: token
                });
            } catch (error) {
                context.commit('error', error);
            }
        }
    },
    mutations: {
        error(state, error) {
            state.error = error;
        }
    }
}